import axios from "axios";

export default axios.create({
    baseURL: "https://cms-java-backend.herokuapp.com",
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
    }
})